module.exports = __webpack_public_path__ + "img/bitbank.8fe0ae28.png";